import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import "./footer.scss";

function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="">
        <div className="inner-wrapper">
          <div className="footer-col">
            <ul>
              <li>
                <h4>{t("COMPANY")}</h4>
              </li>

              <li>
                {" "}
                <a href="https://edusity.com/about" target="_blank">
                  {t("About US")}
                </a>
              </li>
              <li>
                <a
                  href="https://enterprise.edusity.com/terms-conditions"
                  target="_blank"
                >
                  {t("Terms")}
                </a>
              </li>
              <li>
                <a
                  href="https://enterprise.edusity.com/privacy-policy"
                  target="_blank"
                >
                  {t("Privacy")}
                </a>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <ul>
              <li>
                <h4>{t("CONTACT")}</h4>
              </li>

              <li>
                {" "}
                <a href="https://edusity.com/contact" target="_blank">
                  {t("Contact Us")}
                </a>
              </li>
              <li>
                {" "}
                <a
                  href="https://enterprise.edusity.com/support"
                  target="_blank"
                >
                  {t("Help & Support")}
                </a>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <div className="footer-subtitle">{t("Connect with us")}</div>

            <ul className="social-icons">
              <li className="twitter-icon">
                <a
                  aria-label="Link to Twitter"
                  href="https://twitter.com/Edusityglobal"
                  rel="noopener noreferrer"
                  target="_blank"
                ></a>
              </li>

              <li className="facebook-icon">
                <a
                  aria-label="Link to Facebook"
                  href="https://www.facebook.com/Edusitycom/"
                  rel="noopener noreferrer"
                  target="_blank"
                ></a>
              </li>

              <li className="instagram-icon">
                <a
                  aria-label="Link to Instagram"
                  href="https://www.instagram.com/edusityglobal/"
                  rel="noopener noreferrer"
                  target="_blank"
                ></a>
              </li>

              <li className="linkedin-icon">
                <a
                  aria-label="Link to Linked In"
                  href="https://www.linkedin.com/company/edusity/"
                  rel="noopener noreferrer"
                  target="_blank"
                ></a>
              </li>
            </ul>

            <div className="footer-subtitle">{t("Coming Soon")}</div>

            <ul>
              <li>
                <a href="#">IOS</a>
              </li>
              <li>
                <a href="#">Android</a>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <ul></ul>
          </div>
        </div>

        <div className="bottom-footer">
          <div>
            <a
              href="https://edusity.com/"
              title="Edusity Home"
              className="navbar-brand"
              target="_blank"
            >
              <img
                alt="Edusity Logo"
                src="https://cdn.edusity.com/edusity-logo.svg"
                width="200"
              />
            </a>
            <div className="copyright">&copy; Copyright 2023. Edusity Inc.</div>
          </div>

          <div>
            <a
              href="https://cudoo.com/?utm_source=Edusity_Footer&utm_medium=Edusity_Footer&utm_campaign=Edusity_Footer"
              target="_blank"
            >
              <img
                src="https://cdn.edusity.com/Cudoo+%2B+Edusity.png"
                width="210"
                className="cudos-footer"
                alt="cudos-logo"
              />
            </a>
          </div>
          <div>
            <a
              href=" https://www.professorservices.com/?utm_source=Edusity_Footer&utm_medium=Edusity_Footer&utm_campaign=Edusity_Footer"
              target="_blank"
            >
              <img
                src="https://dev.professorservices.com/css/frontendV2/images/professor-services-logo.png"
                width="150"
                className="professor-footer"
                alt="cudos-logo"
              />
            </a>
          </div>
          <div>
            <a
              href="https://www.thebabbgroup.com/?utm_source=Edusity_Footer&utm_medium=Edusity_Footer&utm_campaign=Edusity_Footer"
              target="_blank"
            >
              <img
                src="https://www.thebabbgroup.com/wp-content/uploads/2022/06/logo.png"
                width="140"
                className="babb-footer"
                alt="cudos-logo"
              />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
